import { Box, Button, Text, TextArea } from "@familyzone/component-library";
import { useEffect, useState } from "react";
import React from "react";
import posthog from "posthog-js";
import { colors } from "../../../theme";
// No import needed - we'll use the public URL directly
interface FeedbackProps {
  isVisible: boolean;
}

export const Feedback: React.FC<FeedbackProps> = ({ isVisible }) => {
  const [isFeedbackSent, setIsFeedbackSent] = useState(false);
  const [selectedRating, setSelectedRating] = useState<number | null>(null);
  const [comment, setComment] = useState("");

  const handleSubmit = () => {
    posthog.capture("user_feedback", {
      product: "Product Training",
      rating: selectedRating,
      comment: comment,
    });

    // Show success state
    setIsFeedbackSent(true);
  };

  // Reset the form when the component is hidden/shown
  useEffect(() => {
    if (!isVisible) {
      setIsFeedbackSent(false);
      setSelectedRating(null);
      setComment("");
    }
  }, [isVisible]);

  if (!isVisible) return null;

  if (isFeedbackSent) {
    return (
      <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "8px", padding: "24px", backgroundColor: "white", marginTop: "32px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
          <Box sx={{ width: "96px", height: "83px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img src="/static/images/paper-plane.svg" alt="Paper plane" width="96" height="83" />
          </Box>
          <Text sx={{ fontSize: "18px", fontWeight: "500", color: colors.text.title }}>Thank you</Text>
          <Text sx={{ fontSize: "16px", color: colors.text.title, textAlign: "center" }}>Your feedback has been sent to our team</Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "8px", padding: "24px", backgroundColor: "white", marginTop: "32px" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Text fontFamily="heading" fontWeight="500" fontSize="18px" color={colors.neutrals["700"]}>
          Product Training Feedback
        </Text>

        <Text sx={{ fontSize: "14px", color: colors.neutrals["700"] }}>
          Your insights help us improve our product training resources. Please share your thoughts or requests below.
        </Text>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", width: "468px" }}>
          <Text sx={{ fontSize: "14px", fontWeight: "500", color: "#364255" }}>
            How satisfied are you with our product training resources?
          </Text>
          <Box sx={{ display: "flex", gap: "12px" }}>
            {Array.from({ length: 10 }, (_, i) => (
              <Box
                key={i + 1}
                sx={{
                  border: `1px solid ${selectedRating === i + 1 ? "#D2DAE5" : "#E2E8F0"}`,
                  borderRadius: "6px",
                  padding: "8px",
                  width: "36px",
                  height: "36px",
                  textAlign: "center",
                  cursor: "pointer",
                  color: colors.text.title,
                  backgroundColor: selectedRating === i + 1 ? "#D2DAE5" : "white",
                  transition: "all 0.2s",
                  "&:hover": {
                    backgroundColor: "#D2DAE5",
                    borderColor: "#D2DAE5",
                  },
                }}
                onClick={() => setSelectedRating(i + 1)}
              >
                {i + 1}
              </Box>
            ))}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Text sx={{ fontSize: "12px", color: "#68768B" }}>Very dissatisfied</Text>
            <Text sx={{ fontSize: "12px", color: "#68768B" }}>Very satisfied</Text>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Text sx={{ fontSize: "14px", color: colors.text.title, fontWeight: "600" }}>Comments</Text>
          <TextArea
            placeholder="Please share any additional thoughts or suggestions here."
            rows={5}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Box>

        <Button variant="primary" w="130px" onClick={handleSubmit} disabled={selectedRating === null}>
          Share feedback
        </Button>
      </Box>
    </Box>
  );
};
